import React, {
  useEffect,
  useReducer,
  useState,
  useRef,
  useCallback,
} from 'react';
import { useParams, useSearchParams, useLocation } from 'react-router-dom';
import axios from 'axios';

import Breadcrumb from '../../layouts/Breadcrumb';
import PostDetail from './compoments/PostDetail';
import RightSidebar from './compoments/RightSidebar';
import EnrollmentForm from '../enrollment/EnrollmentForm';
import LoadingBox from '../../compoment/LoadingBox';
import MessageBox from '../../compoment/MessageBox';
import PostList from './compoments/PostList';
import Pagination from '../../compoment/Pagination';
import Comments from './compoments/Comments';
import { EmptyPost } from './compoments/EmptyPost';

const initialState = {
  post: null,
  topicPost: [],
  relatedPosts: [],
  loading: true,
  error: '',
};

const reducer = (state, action) => {
  switch (action.type) {
    case 'FETCH_REQUEST':
      return { ...state, loading: true, error: '' };
    case 'FETCH_SUCCESS':
      return { ...state, ...action.payload, loading: false };
    case 'FETCH_FAIL':
      return { ...state, loading: false, error: action.payload };
    default:
      return state;
  }
};

const PostScreen = () => {
  const [{ loading, error, post, topicPost, relatedPosts }, dispatch] =
    useReducer(reducer, initialState);

  const { slug, title } = useParams();
  const [searchParams] = useSearchParams();
  const location = useLocation();
  const commentsRef = useRef(null);
  const [breadcrumb, setBreadcrumb] = useState({ title: '', slug: '' });
  const [pageIndex, setPageIndex] = useState(1);

  const fetchPostData = useCallback(async () => {
    dispatch({ type: 'FETCH_REQUEST' });
    try {
      const [postRes, postsRes, topicsRes] = await Promise.all([
        slug
          ? axios.get(`/post/show/${slug}`)
          : Promise.resolve({ data: { data: null } }),
        axios.get(`/post/public/shows`, {
          params:
            title === 'tim-kiem'
              ? {
                  keyword: searchParams.get('keyword')?.trim() || '',
                  page: pageIndex,
                  limit: 10,
                }
              : { topicSlug: title, page: pageIndex, limit: 10 },
        }),
        axios.get('/topic/public/shows'),
      ]);

      const currentPost = postRes.data.data;
      const topicPosts = postsRes.data.data.posts || [];
      const topicList = topicsRes.data.data.topics || [];

      const relatedPosts = topicPosts
        .filter((p) => p.slug !== currentPost?.slug)
        .slice(0, 3);

      const currentTopic = topicList.find((topic) => topic.slug === title);

      if (currentTopic) {
        setBreadcrumb({ title: currentTopic.name, slug: currentTopic.slug });
      }

      dispatch({
        type: 'FETCH_SUCCESS',
        payload: {
          post: currentPost,
          topicPost: postsRes.data.data,
          relatedPosts,
        },
      });
    } catch (err) {
      dispatch({ type: 'FETCH_FAIL', payload: err.message });
    }
  }, [slug, title, pageIndex, searchParams]);

  useEffect(() => {
    fetchPostData();
  }, [fetchPostData]);

  useEffect(() => {
    if (location.state?.scrollToComments && commentsRef.current) {
      commentsRef.current.scrollIntoView({ behavior: 'smooth' });
    }
  }, [location]);

  if (loading) return <LoadingBox />;
  if (error) return <MessageBox variant="danger">{error}</MessageBox>;

  const topicForSEO =
    topicPost.posts?.[0]?.topics?.[0] ||
    (breadcrumb.title ? breadcrumb : { slug: 'khong-co', name: 'Bài viết' });

  return (
    <div>
      <Breadcrumb />
      <section className="post-layout">
        <div className="container">
          <div className="row">
            <div className="col-lg-9 col-md-9 col-12">
              {slug && post && (
                <>
                  <PostDetail data={post} />
                  <div ref={commentsRef} id="comments">
                    <Comments ableId={post.id} />
                  </div>
                </>
              )}

              {!slug && topicPost.posts?.length > 0 && (
                <PostList topic={topicForSEO} data={topicPost.posts} />
              )}

              {!slug && (!topicPost.posts || topicPost.posts.length === 0) && (
                <EmptyPost />
              )}
            </div>

            <div className="col-lg-3 col-md-3 col-12">
              <RightSidebar title={title} relatedPosts={relatedPosts} />
            </div>
          </div>

          {!slug && topicPost.totalPages > 1 && (
            <Pagination
              onTop={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
              setPage={setPageIndex}
              totalPages={topicPost.totalPages}
              currentPage={topicPost.currentPage}
            />
          )}
        </div>
        <EnrollmentForm />
      </section>
    </div>
  );
};

export default PostScreen;
